import Natural from "./Natural"
import Sharp from "./Sharp"

const QuarterNote = ({x, y, width, height, sharp, natural}) => {
    return (
        <g fill="#000000">
            {(sharp) ? <Sharp x={x - width * 1.5} y={y} width={width / 3 * 2} height={width / 4 * 3}/> : <g />}
            {(natural) ? <Natural x={x - width * 1.5} y={y} width={width / 3 * 2} height={width / 4 * 3}/> : <g />}
            <ellipse cx={x - width / 2} cy={y} rx={width / 2} ry={(width - 2) / 2}/>
            <line x1={x} x2={x} y1={y} y2 = {y - height} strokeWidth={2} stroke="#000000"/>
        </g>
    )
}

export default QuarterNote